// extracted by mini-css-extract-plugin
export default {"profile-data":"Activity_profile-data__aeGD5","Activity-feed":"Activity_Activity-feed__Qsi5U"};